import { PagerParams, PagerResponse } from 'src/app/core/dtos';
import { LineStatus } from '../../whitepages/lines/enums/line-status.enum';
import { LineType } from '../../whitepages/lines/enums/line-type.enum';

export interface GetGroupLinesConsumptionsAverageParams {
  groupId: string;
  startTime?: string;
  maxCount?: number;
  unit: UsageInterval;
}

export interface GetGroupLinesConsumptionsAverageResponse {
  consumptionAverage: LineConsumptionAverage[];
  unit: number;
}
export interface GetGroupLinesConsumptionsDetailedParams extends PagerParams {
  groupId?: string;
  startTime?: string;
  lineStatus?: LineStatus;
  lineType?: LineType;
  dataFilter?: DataFilter;
  smsFilter?: SmsFilter;
  voiceFilter?: VoiceFilter;
}

export interface GetGroupLinesConsumptionsDetailedResponse
  extends PagerResponse {
  lineConsumptions: GroupLineConsumptionDetail[];
}

export interface LineConsumptionAverage {
  sms: number;
  voice: number;
  dataBalance: DataBalance[];
  startTime: string | Date;
}

export interface GroupLineConsumptionDetail {
  lineId: string;
  lineStatus: LineStatus;
  lineType: LineType;
  phoneNumber: string;
  iccid: string;
  imei: string;
  sms: number;
  voice: number;
  dataBalance: DataBalance[];
  modifiedTs: Date;
}

export interface DataBalance {
  consumed?: number;
  prediction?: number;
  trafficLabelId?: string;
  trafficLabelName?: string;
}

export interface DataFilter {
  min?: number;
  max?: number;
}

export interface SmsFilter {
  min?: number;
  max?: number;
}

export interface VoiceFilter {
  min?: number;
  max?: number;
}

export enum UsageInterval {
  UNSET_INTERVAL = 'UNSET_INTERVAL', // Do not use, needed because of proto3 limitations
  DAY = 'DAY',
  WEEK = 'WEEK',
  MONTH = 'MONTH',
}
